import { render } from "./PromoteIcon.vue?vue&type=template&id=7223195c&scoped=true"
import script from "./PromoteIcon.vue?vue&type=script&lang=js"
export * from "./PromoteIcon.vue?vue&type=script&lang=js"

import "./PromoteIcon.vue?vue&type=style&index=0&id=7223195c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7223195c"]])

export default __exports__